import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from '~/utils/navigation';

import BinaryQuestion from '~/components/binary-question';
import Loading from '~/components/misc/loading';
import { Modal } from '~/components/modal/modal-old';
import { ROUTE_ACCOUNT_WE_SPIN_DASHBOARD } from '../..';

import useTranslations from '~/components/translation/use-translations';
import { removeEvent } from '../../ducks/we-spin-dashboard-duck';
import { WE_SPIN_MODALS_TEXT_KEYS } from '../../constants/we-spin-text-keys';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';

/**
 * Modal for confirming the removal of an event.
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.openConfirmRemove - Whether the remove event modal is open.
 * @param {Function} props.closeConfirmRemove - Function to close the remove event modal.
 * @param {string} props.streamRef - Unique reference ID for the stream.
 * @returns {JSX.Element}
 */
const RemoveEventModal = props => {
	const dispatch = useDispatch();
	const router = useRouter();
	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_MODALS_TEXT_KEYS);
	const [submitting, setSubmitting] = useState(false);
	const transformPath = useContextualPathTransformer();

	const removeSelected = useCallback(async () => {
		try {
			setSubmitting(true);
			await dispatch(removeEvent(props.streamRef));
			props.closeConfirmRemove();
			router.replace(transformPath(ROUTE_ACCOUNT_WE_SPIN_DASHBOARD));
		} finally {
			setSubmitting(false);
		}
	}, [dispatch, props, router, transformPath]);

	if (isLoadingTranslations) return <Loading />;

	return (
		<Modal show={props.openConfirmRemove} position="fixed">
			<BinaryQuestion
				shouldOpenBinary
				renderInParent
				buttonsHasUncontrolledLoading={submitting}
				title={tr.WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_TITLE}
				yesText={tr.WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_YES_BUTTTON}
				noText={tr.WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_NO_BUTTTON}
				onYesClick={removeSelected}
				onNoClick={props.closeConfirmRemove}
			>
				<p>{tr.WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_TEXT}</p>
			</BinaryQuestion>
		</Modal>
	);
};

export default RemoveEventModal;
